import { styled } from '@mui/material';

export const StyledImage = styled('img')(({ theme }) => ({
  borderRadius: theme.spacing(3),
  width: theme.spacing(65),
  height: theme.spacing(49),
  [theme.breakpoints.up('md')]: {
    width: theme.spacing(150),
    height: theme.spacing(112.5),
  },
}));

export const StyledKeepMountedVideo = styled('video')<{ show: boolean }>(
  ({ theme, show }) => ({
    display: show ? 'none' : 'block',
    borderRadius: theme.spacing(3),
    width: theme.spacing(65),
    height: theme.spacing(49),
    [theme.breakpoints.up('md')]: {
      width: theme.spacing(150),
      height: theme.spacing(112.5),
    },
  }),
);
